import script from "./Instructor.vue?vue&type=script&lang=ts&setup=true"
export * from "./Instructor.vue?vue&type=script&lang=ts&setup=true"

import "./Instructor.vue?vue&type=style&index=0&id=3a91f26e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a91f26e"]])

export default __exports__